export default {
  computed: {
    isExtraDataIncorrect() {
      return this.userData.role === 'lender' ? false : !this.extra_user_info.total_income || !this.extra_user_info.dependens_number;
    }
  }
}